import axios from "axios";

const baseUrl = `${process.env.REACT_APP_API}/zoho`;
const endpoint = `${baseUrl}/books/vendors`;

const headers = {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
};

/**
 * Create a vendor in Zoho Books.
 * @param {Object} data - Vendor data including contact_name (required), company_name, billing_address, etc.
 * @returns {Promise<Object>} - Resolves with { zoho_vendor_id, ...contact }
 */
export const createZohoVendor = async (data) => {
    const response = await axios.post(endpoint, data, { headers });
    return response.data;
};

/**
 * Update a vendor in Zoho Books.
 * @param {string} zohoVendorId - The Zoho vendor/contact ID
 * @param {Object} data - Fields to update (contact_name, company_name, billing_address, etc.)
 * @returns {Promise<Object>} - Resolves with { zoho_vendor_id, ...contact }
 */
export const updateZohoVendor = async (zohoVendorId, data) => {
    const response = await axios.put(`${endpoint}/${zohoVendorId}`, data, { headers });
    return response.data;
};

/**
 * Delete a vendor from Zoho Books.
 * @param {string} zohoVendorId - The Zoho vendor/contact ID
 * @returns {Promise<Object>} - Resolves with { zoho_vendor_id, deleted: true }
 */
export const deleteZohoVendor = async (zohoVendorId) => {
    const response = await axios.delete(`${endpoint}/${zohoVendorId}`, { headers });
    return response.data;
};
